import React from "react";
import "./CategoryBanner.scss";
const CategoryBanner = props => {
    const {channel} = props;
    return <div className={"container category-banner-container"}>
        <div className={"row"}>
            <div className={"col-md-12"}>
                <div className={"category-hero-image"}>
                    <div className={"category-hero-title"}>
                        {channel.title}
                    </div>
                </div>
            </div>
        </div>
    </div>
};

CategoryBanner.defaultProps = {
    channel: {
        title: ""
    }
}

export default CategoryBanner;
